import { trackEvent } from './segmentService'

export const normalizeValue = (value) => {
  if (value === undefined || value === null) return ''
  if (typeof value === 'number' || typeof value === 'boolean') {
    return String(value)
  }
  if (typeof value === 'object') {
    try {
      return JSON.stringify(value)
    } catch (error) {
      return ''
    }
  }
  return value
}

export const normalizeExtraData = (extra = {}) =>
  Object.keys(extra).reduce((acc, key) => {
    const value = extra[key]
    if (value === undefined || value === null) {
      return acc
    }
    return {
      ...acc,
      [key]: normalizeValue(value)
    }
  }, {})

export const getPageSource = () => {
  if (typeof window === 'undefined') return 'player'
  const { pathname } = window.location
  return pathname || 'player'
}

export const trackDownloadEvent = (event, download, extra = {}) => {
  if (!download) return
  const payload = {
    id: normalizeValue(download.mediaID),
    artist: normalizeValue(download.artist),
    title: normalizeValue(download.title),
    type: normalizeValue(download.type),
    format: normalizeValue(download.format),
    track_count: normalizeValue(download.trackcount || ''),
    version: normalizeValue(download.version),
    ordinal: normalizeValue(download.ordinal),
    explicit: normalizeValue(download.explicit),
    source: normalizeValue(download.sourceLabel || 'download'),
    ...extra
  }
  trackEvent(event, payload)
}

export const trackQueueEvent = (event, item, extra = {}) => {
  if (!item) return
  const payload = {
    id: normalizeValue(item.trackid || item.releaseid || item.playlistid),
    artist: normalizeValue(item.artist),
    title: normalizeValue(item.title),
    item_type: item.trackid
      ? 'song'
      : item.releaseid
      ? 'release'
      : item.playlistid
      ? 'playlist'
      : '',
    source: normalizeValue(extra.source || 'player'),
    type: normalizeValue(extra.type || 'queue'),
    ...extra
  }
  trackEvent(event, payload)
}
